import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InvestmentObjectivesEffects } from './investment-objectives.effects';
import { STORE_TYPE } from './investment-objectives.model';
import { investmentObjectivesReducer } from './investment-objectives.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_TYPE, investmentObjectivesReducer),
    EffectsModule.forFeature([InvestmentObjectivesEffects]),
  ],
})
export class UIInvestmentObjectivesStoreModule {}